

import {Component, Vue} from "vue-property-decorator";
import {CreateFolderDTO} from "@fenix/file-manager-entities/file-manager-entities";

@Component({})
export default class CreateRootFolderModal extends Vue {
  private visible= true;
  private isFormValid = false;
  private newFolder: CreateFolderDTO = {name: '', isPrivate: true};
  private visibility = [{name: 'Private', value: true}, {name: 'Public', value: false}]

  private submitCreate() {
    this.visible = false;
    this.$emit('submit-create-root-folder-modal', this.newFolder);
    this.$destroy();
  }

  private destroyComponent(): void {
    this.$emit('close-create-root-folder-modal');
    this.$destroy();
  }}
